import React, { createContext, useContext } from 'react';

import { SubscriptionItemProps } from '../../../../store/subscription/types';

interface SubscriptionDetailContextReceivedData {}

interface SubscriptionDetailContextData extends SubscriptionDetailContextReceivedData {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  subscriptionSelected: SubscriptionItemProps | undefined;
  setSubscriptionSelected: React.Dispatch<React.SetStateAction<SubscriptionItemProps | undefined>>;
}

interface Props extends SubscriptionDetailContextReceivedData {
  children: React.ReactNode;
}

const SubscriptionDetailContext = createContext<SubscriptionDetailContextData>(
  {} as SubscriptionDetailContextData
);

const SubscriptionDetailProvider: React.FC<Props> = ({ children, ...props }) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [subscriptionSelected, setSubscriptionSelected] = React.useState<SubscriptionItemProps>();

  return (
    <SubscriptionDetailContext.Provider
      value={{
        ...props,
        modalOpen,
        setModalOpen,
        subscriptionSelected,
        setSubscriptionSelected,
      }}>
      {children}
    </SubscriptionDetailContext.Provider>
  );
};

const useSubscriptionDetailContext = (): SubscriptionDetailContextData => {
  const context = useContext(SubscriptionDetailContext);

  if (!context) {
    throw new Error(
      'useSubscriptionDetailContext must be used within an SubscriptionDetailContext'
    );
  }
  return context;
};

export { SubscriptionDetailProvider, useSubscriptionDetailContext, SubscriptionDetailContextData };
